export const convertNumberDecimal = (value: number) => {
  if (Number.isInteger(value)) {
    return value;
  }

  const decimals = (value.toString().split(".")[1] || "").length;

  if (decimals > 2) {
    return parseFloat(value.toFixed(2));
  }

  return value;
};
